import { render, staticRenderFns } from "./VideoPlayerMobile.vue?vue&type=template&id=1dc3088e"
import script from "./VideoPlayerMobile.vue?vue&type=script&lang=js"
export * from "./VideoPlayerMobile.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerMobile.vue?vue&type=style&index=0&id=1dc3088e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports